<div
  *ngIf="!isCurrentTabActive()"
  class="fixed inset-0 z-[99999] flex items-center justify-center p-4 bg-slate-950/60 backdrop-blur-md transition-all duration-300 animate-in fade-in"
>
  <div
    class="relative w-full max-w-md overflow-hidden rounded-2xl border border-slate-200/80 bg-white/95 p-6 sm:p-8 text-center shadow-2xl backdrop-blur-xl"
  >
    <!-- Background subtle decoration -->
    <div
      class="pointer-events-none absolute -top-16 -right-16 h-36 w-36 rounded-full bg-primary/10 blur-2xl"
    ></div>
    <div
      class="pointer-events-none absolute -bottom-16 -left-16 h-36 w-36 rounded-full bg-amber-500/10 blur-2xl"
    ></div>

    <!-- PBPA Logo / Icon header -->
    <div class="relative mx-auto mb-5 flex items-center justify-center">
      <div
        class="relative flex h-20 w-20 items-center justify-center rounded-2xl bg-slate-50 p-2 shadow-inner ring-1 ring-slate-200"
      >
        <img
          src="/images/logo.png"
          alt="PBPA Logo"
          class="h-14 w-14 object-contain rounded-xl"
        />
      </div>
    </div>

    <!-- Warning / Status Badge -->
    <div class="mb-3 inline-flex items-center gap-1.5 rounded-full bg-amber-50 px-3 py-1 text-xs font-semibold text-amber-800 border border-amber-200">
      <lucide-icon [img]="Monitor" [size]="14" class="text-amber-600"></lucide-icon>
      <span>{{ 'PBPA MIS is open in another tab' | translate }}</span>
    </div>

    <!-- Title & Description -->
    <h2 class="text-xl sm:text-2xl font-bold tracking-tight text-slate-900">
      {{ 'Application Open in Another Window' | translate }}
    </h2>
    <p class="mt-2 text-sm text-slate-700 leading-relaxed">
      {{ 'PBPA MIS is currently active in another browser tab or window. To keep your session and data consistent, only one tab can be active at a time.' | translate }}
    </p>

    <!-- Action Button -->
    <div class="mt-6 flex flex-col gap-2.5 sm:flex-row sm:justify-center">
      <button
        type="button"
        (click)="useHere()"
        class="inline-flex w-full sm:w-auto items-center justify-center gap-2 rounded-xl bg-primary px-6 py-2.5 text-sm font-semibold text-white shadow-md transition-all hover:bg-primary/90 hover:shadow-lg active:scale-95 focus:outline-none focus:ring-2 focus:ring-primary/40"
      >
        <lucide-icon [img]="RotateCcw" [size]="16"></lucide-icon>
        <span>{{ 'Use Here' | translate }}</span>
      </button>
    </div>

    <!-- Footer Note -->
    <p class="mt-4 text-xs text-slate-600">
      {{ 'Clicking "Use Here" will activate this tab and pause the other one.' | translate }}
    </p>
  </div>
</div>
